var map = {
	"./Avatar The Way of Water.jpg": 9964,
	"./Creed 3.jpg": 4081,
	"./John Wick 4.jpg": 1687,
	"./Modern Family.jpg": 183,
	"./Red Notice.jpg": 891,
	"./Run.jpg": 1304,
	"./Succession.jpg": 1996,
	"./The Last Dance.jpg": 2397,
	"./Vikram.jpg": 7710,
	"./Wednesday.jpg": 5935
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7561;